import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function GuestSharingSuccessPage() {
    const { type, id } = useParams();

    const { t } = useTranslation();

    return (
        <IonPage>
            <IonContent>
                <section id="whatsapp-success-page" className="relative pt-8 pb-32 font-sans text-center">
                    <div className="px-8">
                        <h2 className="font-bold text-4xl">{t("guestsharingsuccesspage.h2_1")}</h2>
                        <p className="mt-8">{t("guestsharingsuccesspage.p_1")}</p>
                    </div>
                    <img src="/assets/images/checkout_success.png" className="w-1/2 m-auto pt-12" alt="checkout success" />

                    <div className="fixed bottom-0 w-full flex flex-col justify-center mt-8 px-4 py-6 bg-white">
                        <a href={`/${type}/q/${id}/menu`} className="block py-2 rounded-full bg-mycia-green">{t("guestsharingsuccesspage.p_2")}</a>
                    </div>
                </section>
            </IonContent>
        </IonPage>
    );
}
